import { EventBus } from "@/infrastructure/services/events/EventBus";
import { IAllEventsMap } from "@/core/events/allEventsMap";

export class EventBusAdapter {
    private readonly eventBus: EventBus<IAllEventsMap>;

    constructor() {
        this.eventBus = EventBus.getInstance();
    }

    public static getInstance(): EventBusAdapter {
        if (!EventBusAdapter.instance) {
            EventBusAdapter.instance = new EventBusAdapter();
        }
        return EventBusAdapter.instance;
    }

    public on<K extends keyof IAllEventsMap>(event: K, handler: (payload: IAllEventsMap[K]) => void): void {
        this.eventBus.on(event, handler);
    }

    public off<K extends keyof IAllEventsMap>(event: K, handler: (payload: IAllEventsMap[K]) => void): void {
        this.eventBus.off(event, handler);
    }

    public async emit<K extends keyof IAllEventsMap>(event: K, payload: IAllEventsMap[K], options?: { timeout?: number; onTimeout?: (event: string, handlerIndex: number) => void }): Promise<void> {
        await this.eventBus.emit(event, payload, options);
    }

    public emitOnce<K extends keyof IAllEventsMap>(event: K, handler: (payload: IAllEventsMap[K]) => void): void {
        this.eventBus.emitOnce(event, handler);
    }

    public clearAll(): void {
        this.eventBus.clearAll();
    }

    public getSubscriberCount<K extends keyof IAllEventsMap>(event: K): number {
        return this.eventBus.getSubscriberCount(event);
    }

    private static instance: EventBusAdapter;
}

export const eventBusAdapter = EventBusAdapter.getInstance();
